import * as React from 'react';
import { resetFilters } from '../actions';
import { directoryDispatch } from '../affiliate-directory';

interface IDirectoryFiltersReset {
  classModifier?: string;
  actions?: any;
}

class DirectoryFiltersReset extends React.Component<IDirectoryFiltersReset, any>{
  constructor(props, context)
  {
    super(props, context);

    this.resetFilters = this.resetFilters.bind(this);
  }

  render()
  {
    return (
      <a className={'btn-reset directory-reset-btn btn-solid'} onClick={this.resetFilters} href="#">Reset</a>
    )
  }

  resetFilters(e)
  {
    e.preventDefault();
    directoryDispatch()(resetFilters());
  }
}

export default DirectoryFiltersReset;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/filters/directory-filters-reset.tsx